module.exports = __webpack_public_path__ + "img/Burning-Rose-Tattoo-by-Andrés-Acosta-728x728.jpg";